import o from "./components/icons/accessibility-mac.js";
import _ from "./components/icons/accessibility.js";
import i from "./components/icons/activity.js";
import r from "./components/icons/add-task.js";
import t from "./components/icons/agent-assist.js";
import s from "./components/icons/ai-notes.js";
import e from "./components/icons/ai-write.js";
import c from "./components/icons/airplay.js";
import n from "./components/icons/airtable.js";
import l from "./components/icons/alarm-check.js";
import a from "./components/icons/alarm-clock-off.js";
import m from "./components/icons/alarm-minus.js";
import v from "./components/icons/alarm-plus.js";
import u from "./components/icons/album.js";
import p from "./components/icons/alert-circle.js";
import g from "./components/icons/alert-triangle.js";
import f from "./components/icons/align-center.js";
import b from "./components/icons/align-justify.js";
import D from "./components/icons/align-left.js";
import I from "./components/icons/align-right.js";
import d from "./components/icons/amex.js";
import h from "./components/icons/app-store-badge.js";
import k from "./components/icons/apple.js";
import C from "./components/icons/archive-restore.js";
import w from "./components/icons/archive.js";
import y from "./components/icons/arrow-down-left.js";
import S from "./components/icons/arrow-down-right.js";
import M from "./components/icons/arrow-down.js";
import B from "./components/icons/arrow-left-right.js";
import A from "./components/icons/arrow-left.js";
import F from "./components/icons/arrow-right.js";
import L from "./components/icons/arrow-up-down.js";
import P from "./components/icons/arrow-up-left.js";
import T from "./components/icons/arrow-up-right.js";
import R from "./components/icons/arrow-up.js";
import O from "./components/icons/asana.js";
import x from "./components/icons/asterisk.js";
import z from "./components/icons/at-sign.js";
import U from "./components/icons/ata-adapter.js";
import H from "./components/icons/attestation-outline.js";
import G from "./components/icons/attestation.js";
import V from "./components/icons/axis-3d.js";
import W from "./components/icons/bar-chart-2.js";
import E from "./components/icons/bar-chart-3.js";
import N from "./components/icons/bar-chart-4.js";
import q from "./components/icons/bar-chart-horizontal.js";
import Z from "./components/icons/bar-chart.js";
import j from "./components/icons/barge.js";
import Q from "./components/icons/baseline.js";
import X from "./components/icons/battery-charging.js";
import J from "./components/icons/battery-full.js";
import K from "./components/icons/battery-low.js";
import Y from "./components/icons/battery-medium.js";
import $ from "./components/icons/battery.js";
import oo from "./components/icons/bell-minus.js";
import _o from "./components/icons/bell-off.js";
import io from "./components/icons/bell-plus.js";
import ro from "./components/icons/bell-ring.js";
import to from "./components/icons/bell.js";
import so from "./components/icons/binary.js";
import eo from "./components/icons/bluetooth-connected.js";
import co from "./components/icons/bluetooth-off.js";
import no from "./components/icons/bluetooth-searching.js";
import lo from "./components/icons/bluetooth.js";
import ao from "./components/icons/blur-background.js";
import mo from "./components/icons/bold.js";
import vo from "./components/icons/book-open.js";
import uo from "./components/icons/book.js";
import po from "./components/icons/bookmark-filled.js";
import go from "./components/icons/bookmark-minus.js";
import fo from "./components/icons/bookmark-plus.js";
import bo from "./components/icons/bookmark.js";
import Do from "./components/icons/box-select.js";
import Io from "./components/icons/box.js";
import ho from "./components/icons/boxes.js";
import ko from "./components/icons/branch.js";
import Co from "./components/icons/brand-dialpad-meetings.js";
import wo from "./components/icons/brand-dialpad.js";
import yo from "./components/icons/breakout-rooms.js";
import So from "./components/icons/briefcase.js";
import Mo from "./components/icons/building-2.js";
import Bo from "./components/icons/building.js";
import Ao from "./components/icons/bullet.js";
import Fo from "./components/icons/bullhorn.js";
import Lo from "./components/icons/calculator.js";
import Po from "./components/icons/calendar-check-2.js";
import To from "./components/icons/calendar-check.js";
import Ro from "./components/icons/calendar-clock.js";
import Oo from "./components/icons/calendar-days.js";
import xo from "./components/icons/calendar-heart.js";
import zo from "./components/icons/calendar-minus.js";
import Uo from "./components/icons/calendar-off.js";
import Ho from "./components/icons/calendar-plus.js";
import Go from "./components/icons/calendar-range.js";
import Vo from "./components/icons/calendar-search.js";
import Wo from "./components/icons/calendar-x.js";
import Eo from "./components/icons/calendar.js";
import No from "./components/icons/call-abandoned.js";
import qo from "./components/icons/call-merge.js";
import Zo from "./components/icons/call-rejected.js";
import jo from "./components/icons/camera-off.js";
import Qo from "./components/icons/camera-tracking.js";
import Xo from "./components/icons/camera.js";
import Jo from "./components/icons/cast.js";
import Ko from "./components/icons/check-circle-filled.js";
import Yo from "./components/icons/check-circle.js";
import $o from "./components/icons/check.js";
import o_ from "./components/icons/chevron-down.js";
import __ from "./components/icons/chevron-first.js";
import i_ from "./components/icons/chevron-last.js";
import r_ from "./components/icons/chevron-left.js";
import t_ from "./components/icons/chevron-right.js";
import s_ from "./components/icons/chevron-up.js";
import e_ from "./components/icons/chevrons-down-up.js";
import c_ from "./components/icons/chevrons-down.js";
import n_ from "./components/icons/chevrons-left-right.js";
import l_ from "./components/icons/chevrons-left.js";
import a_ from "./components/icons/chevrons-right-left.js";
import m_ from "./components/icons/chevrons-right.js";
import v_ from "./components/icons/chevrons-up-down.js";
import u_ from "./components/icons/chevrons-up.js";
import p_ from "./components/icons/circle-half-filled.js";
import g_ from "./components/icons/circle-slashed.js";
import f_ from "./components/icons/clipboard-check.js";
import b_ from "./components/icons/clipboard-copy.js";
import D_ from "./components/icons/clipboard-edit.js";
import I_ from "./components/icons/clipboard-list.js";
import d_ from "./components/icons/clipboard-signature.js";
import h_ from "./components/icons/clipboard-type.js";
import k_ from "./components/icons/clipboard-x.js";
import C_ from "./components/icons/clipboard.js";
import w_ from "./components/icons/clock-1.js";
import y_ from "./components/icons/clock-10.js";
import S_ from "./components/icons/clock-11.js";
import M_ from "./components/icons/clock-12.js";
import B_ from "./components/icons/clock-2.js";
import A_ from "./components/icons/clock-3.js";
import F_ from "./components/icons/clock-4.js";
import L_ from "./components/icons/clock-5.js";
import P_ from "./components/icons/clock-6.js";
import T_ from "./components/icons/clock-7.js";
import R_ from "./components/icons/clock-8.js";
import O_ from "./components/icons/clock-9.js";
import x_ from "./components/icons/clock.js";
import z_ from "./components/icons/clockify.js";
import U_ from "./components/icons/close.js";
import H_ from "./components/icons/cloud-cog.js";
import G_ from "./components/icons/cloud-drizzle.js";
import V_ from "./components/icons/cloud-fog.js";
import W_ from "./components/icons/cloud-hail.js";
import E_ from "./components/icons/cloud-lightning.js";
import N_ from "./components/icons/cloud-moon-rain.js";
import q_ from "./components/icons/cloud-moon.js";
import Z_ from "./components/icons/cloud-off.js";
import j_ from "./components/icons/cloud-rain-wind.js";
import Q_ from "./components/icons/cloud-rain.js";
import X_ from "./components/icons/cloud-snow.js";
import J_ from "./components/icons/cloud-sun-rain.js";
import K_ from "./components/icons/cloud-sun.js";
import Y_ from "./components/icons/cloud.js";
import $_ from "./components/icons/cloudy.js";
import oi from "./components/icons/coaching-hub.js";
import _i from "./components/icons/code-block.js";
import ii from "./components/icons/code.js";
import ri from "./components/icons/command.js";
import ti from "./components/icons/concierge-bell.js";
import si from "./components/icons/connection-api.js";
import ei from "./components/icons/contacts.js";
import ci from "./components/icons/copper-crm.js";
import ni from "./components/icons/copy.js";
import li from "./components/icons/copyright.js";
import ai from "./components/icons/corner-down-left.js";
import mi from "./components/icons/corner-down-right.js";
import vi from "./components/icons/corner-left-down.js";
import ui from "./components/icons/corner-left-up.js";
import pi from "./components/icons/corner-right-down.js";
import gi from "./components/icons/corner-right-up.js";
import fi from "./components/icons/corner-up-left.js";
import bi from "./components/icons/corner-up-right.js";
import Di from "./components/icons/cpu.js";
import Ii from "./components/icons/credit-card.js";
import di from "./components/icons/dash.js";
import hi from "./components/icons/dect-base-station.js";
import ki from "./components/icons/dect-handset.js";
import Ci from "./components/icons/default-ai-agent-fab.js";
import wi from "./components/icons/delete.js";
import yi from "./components/icons/deskphone.js";
import Si from "./components/icons/dialbot.js";
import Mi from "./components/icons/dialer.js";
import Bi from "./components/icons/dialpad-ai-color-reversed.js";
import Ai from "./components/icons/dialpad-ai-color.js";
import Fi from "./components/icons/dialpad-ai-reversed.js";
import Li from "./components/icons/dialpad-ai.js";
import Pi from "./components/icons/dialpad-analytics-ai.js";
import Ti from "./components/icons/dialpad-logo.js";
import Ri from "./components/icons/dialpad-logomark.js";
import Oi from "./components/icons/dialpad-meetings-star.js";
import xi from "./components/icons/dialpad-sparkle.js";
import zi from "./components/icons/dialpad-star-mark-color.js";
import Ui from "./components/icons/dialpad-star-mark.js";
import Hi from "./components/icons/dialpad-star-reversed.js";
import Gi from "./components/icons/dialpad-star.js";
import Vi from "./components/icons/dialpad-wfm.js";
import Wi from "./components/icons/digital-whisper.js";
import Ei from "./components/icons/diners-club.js";
import Ni from "./components/icons/discover.js";
import qi from "./components/icons/dissatisfied-filled.js";
import Zi from "./components/icons/dissatisfied.js";
import ji from "./components/icons/double-check.js";
import Qi from "./components/icons/download-cloud.js";
import Xi from "./components/icons/download.js";
import Ji from "./components/icons/dp-phone.js";
import Ki from "./components/icons/dpm-logo.js";
import Yi from "./components/icons/edit-2.js";
import $i from "./components/icons/edit.js";
import or from "./components/icons/empty.js";
import _r from "./components/icons/end-chat.js";
import ir from "./components/icons/equal.js";
import rr from "./components/icons/eraser.js";
import tr from "./components/icons/evernote.js";
import sr from "./components/icons/expand.js";
import er from "./components/icons/expert-node.js";
import cr from "./components/icons/external-link.js";
import nr from "./components/icons/eye-off.js";
import lr from "./components/icons/eye.js";
import ar from "./components/icons/facebook.js";
import mr from "./components/icons/factory.js";
import vr from "./components/icons/fast-forward.js";
import ur from "./components/icons/file-audio.js";
import pr from "./components/icons/file-pdf.js";
import gr from "./components/icons/file.js";
import fr from "./components/icons/files.js";
import br from "./components/icons/film.js";
import Dr from "./components/icons/filter.js";
import Ir from "./components/icons/fingerprint.js";
import dr from "./components/icons/flag-off.js";
import hr from "./components/icons/flag.js";
import kr from "./components/icons/flame.js";
import Cr from "./components/icons/focus.js";
import wr from "./components/icons/folder-tree.js";
import yr from "./components/icons/folder.js";
import Sr from "./components/icons/folders.js";
import Mr from "./components/icons/food.js";
import Br from "./components/icons/form-input.js";
import Ar from "./components/icons/forward.js";
import Fr from "./components/icons/freshdesk.js";
import Lr from "./components/icons/freshsales-crm.js";
import Pr from "./components/icons/front.js";
import Tr from "./components/icons/gamepad.js";
import Rr from "./components/icons/gauge.js";
import Or from "./components/icons/gif-filled.js";
import xr from "./components/icons/gif-outline.js";
import zr from "./components/icons/giphy.js";
import Ur from "./components/icons/globe-2.js";
import Hr from "./components/icons/gmail.js";
import Gr from "./components/icons/google-business-messaging.js";
import Vr from "./components/icons/google-calendar.js";
import Wr from "./components/icons/google-docs.js";
import Er from "./components/icons/google-drive.js";
import Nr from "./components/icons/google-glyph.js";
import qr from "./components/icons/google-meet.js";
import Zr from "./components/icons/google-sheets.js";
import jr from "./components/icons/google-slides.js";
import Qr from "./components/icons/graduation.js";
import Xr from "./components/icons/greenhouse.js";
import Jr from "./components/icons/grid.js";
import Kr from "./components/icons/grip-horizontal.js";
import Yr from "./components/icons/grip-vertical.js";
import $r from "./components/icons/hand.js";
import ot from "./components/icons/hard-drive.js";
import _t from "./components/icons/hash-bold.js";
import it from "./components/icons/hash.js";
import rt from "./components/icons/haze.js";
import tt from "./components/icons/hd.js";
import st from "./components/icons/headphones.js";
import et from "./components/icons/headset.js";
import ct from "./components/icons/hear.js";
import nt from "./components/icons/heart.js";
import lt from "./components/icons/help-circle.js";
import at from "./components/icons/highfive.js";
import mt from "./components/icons/history.js";
import vt from "./components/icons/hold.js";
import ut from "./components/icons/home.js";
import pt from "./components/icons/hourglass.js";
import gt from "./components/icons/hubspot.js";
import ft from "./components/icons/image.js";
import bt from "./components/icons/import.js";
import Dt from "./components/icons/inbox.js";
import It from "./components/icons/indent.js";
import dt from "./components/icons/infinity.js";
import ht from "./components/icons/info.js";
import kt from "./components/icons/inspect.js";
import Ct from "./components/icons/instagram.js";
import wt from "./components/icons/intercom.js";
import yt from "./components/icons/isolated-queries.js";
import St from "./components/icons/italic.js";
import Mt from "./components/icons/jcb.js";
import Bt from "./components/icons/jira-service-desk.js";
import At from "./components/icons/key.js";
import Ft from "./components/icons/keyboard.js";
import Lt from "./components/icons/keypad.js";
import Pt from "./components/icons/languages.js";
import Tt from "./components/icons/laptop-2.js";
import Rt from "./components/icons/large-self-view.js";
import Ot from "./components/icons/layout-dashboard.js";
import xt from "./components/icons/layout-filmstrip.js";
import zt from "./components/icons/layout-grid.js";
import Ut from "./components/icons/layout-template.js";
import Ht from "./components/icons/layout.js";
import Gt from "./components/icons/library.js";
import Vt from "./components/icons/life-buoy.js";
import Wt from "./components/icons/lightbulb-off.js";
import Et from "./components/icons/lightbulb.js";
import Nt from "./components/icons/lightning-bolt.js";
import qt from "./components/icons/line-chart.js";
import Zt from "./components/icons/line-messenger.js";
import jt from "./components/icons/link-2-off.js";
import Qt from "./components/icons/link-2.js";
import Xt from "./components/icons/linkedin.js";
import Jt from "./components/icons/list-add.js";
import Kt from "./components/icons/list-bullet.js";
import Yt from "./components/icons/list-checks.js";
import $t from "./components/icons/list-ordered.js";
import os from "./components/icons/listen.js";
import _s from "./components/icons/listening.js";
import is from "./components/icons/live-queue.js";
import rs from "./components/icons/living-thing.js";
import ts from "./components/icons/loading.js";
import ss from "./components/icons/lock-filled.js";
import es from "./components/icons/lock.js";
import cs from "./components/icons/log-in.js";
import ns from "./components/icons/log-out.js";
import ls from "./components/icons/maestro.js";
import as from "./components/icons/mail-open.js";
import ms from "./components/icons/mail.js";
import vs from "./components/icons/mails.js";
import us from "./components/icons/map-pin-filled.js";
import ps from "./components/icons/map-pin.js";
import gs from "./components/icons/map.js";
import fs from "./components/icons/mastercard.js";
import bs from "./components/icons/maximize.js";
import Ds from "./components/icons/megaphone-off.js";
import Is from "./components/icons/megaphone.js";
import ds from "./components/icons/menu.js";
import hs from "./components/icons/message.js";
import ks from "./components/icons/messenger.js";
import Cs from "./components/icons/mic-off.js";
import ws from "./components/icons/mic.js";
import ys from "./components/icons/microsoft-dynamics-365.js";
import Ss from "./components/icons/microsoft-teams.js";
import Ms from "./components/icons/microsoft.js";
import Bs from "./components/icons/minimize-alt.js";
import As from "./components/icons/minimize.js";
import Fs from "./components/icons/minus-circle.js";
import Ls from "./components/icons/miro.js";
import Ps from "./components/icons/monday-com.js";
import Ts from "./components/icons/monitor-off.js";
import Rs from "./components/icons/monitor-speaker.js";
import Os from "./components/icons/monitor.js";
import xs from "./components/icons/moon.js";
import zs from "./components/icons/more-horizontal.js";
import Us from "./components/icons/more-vertical.js";
import Hs from "./components/icons/mouse.js";
import Gs from "./components/icons/multi-line-dept.js";
import Vs from "./components/icons/music-off.js";
import Ws from "./components/icons/music.js";
import Es from "./components/icons/network.js";
import Ns from "./components/icons/neutral.js";
import qs from "./components/icons/newspaper.js";
import Zs from "./components/icons/not-enough-queries.js";
import js from "./components/icons/notes.js";
import Qs from "./components/icons/o365-calendar.js";
import Xs from "./components/icons/object.js";
import Js from "./components/icons/office-365.js";
import Ks from "./components/icons/option.js";
import Ys from "./components/icons/package.js";
import $s from "./components/icons/paperclip.js";
import oe from "./components/icons/park.js";
import _e from "./components/icons/party-popper.js";
import ie from "./components/icons/past-conversations.js";
import re from "./components/icons/pause-circle-filled.js";
import te from "./components/icons/pause-circle.js";
import se from "./components/icons/pause.js";
import ee from "./components/icons/phone-call.js";
import ce from "./components/icons/phone-forward.js";
import ne from "./components/icons/phone-hang-up.js";
import le from "./components/icons/phone-hold.js";
import ae from "./components/icons/phone-incoming.js";
import me from "./components/icons/phone-missed.js";
import ve from "./components/icons/phone-off.js";
import ue from "./components/icons/phone-outgoing.js";
import pe from "./components/icons/phone.js";
import ge from "./components/icons/picture-in-picture.js";
import fe from "./components/icons/pie-chart.js";
import be from "./components/icons/pin-filled.js";
import De from "./components/icons/pin-off.js";
import Ie from "./components/icons/pin.js";
import de from "./components/icons/pipedrive.js";
import he from "./components/icons/play-circle-filled.js";
import ke from "./components/icons/play-circle.js";
import Ce from "./components/icons/play-filled.js";
import we from "./components/icons/play-store-badge.js";
import ye from "./components/icons/play.js";
import Se from "./components/icons/plug.js";
import Me from "./components/icons/plus-circle-filled.js";
import Be from "./components/icons/plus-circle.js";
import Ae from "./components/icons/plus.js";
import Fe from "./components/icons/power-dialer-off.js";
import Le from "./components/icons/power-dialer.js";
import Pe from "./components/icons/power.js";
import Te from "./components/icons/print-fax.js";
import Re from "./components/icons/printer.js";
import Oe from "./components/icons/puzzle.js";
import xe from "./components/icons/qr-code.js";
import ze from "./components/icons/queries.js";
import Ue from "./components/icons/quick-reply.js";
import He from "./components/icons/quote.js";
import Ge from "./components/icons/record-filled.js";
import Ve from "./components/icons/record.js";
import We from "./components/icons/redo.js";
import Ee from "./components/icons/refresh.js";
import Ne from "./components/icons/rematch.js";
import qe from "./components/icons/repeat.js";
import Ze from "./components/icons/reply-all.js";
import je from "./components/icons/reply.js";
import Qe from "./components/icons/rewind-15-sec.js";
import Xe from "./components/icons/rewind.js";
import Je from "./components/icons/rocket.js";
import Ke from "./components/icons/salesforce-glyph.js";
import Ye from "./components/icons/salesforce-logo.js";
import $e from "./components/icons/satisfied-filled.js";
import oc from "./components/icons/satisfied.js";
import _c from "./components/icons/save.js";
import ic from "./components/icons/scan-face.js";
import rc from "./components/icons/scan-file.js";
import tc from "./components/icons/scan.js";
import sc from "./components/icons/scissors.js";
import ec from "./components/icons/screen-share-off.js";
import cc from "./components/icons/scroll.js";
import nc from "./components/icons/search.js";
import lc from "./components/icons/send.js";
import ac from "./components/icons/servicenow.js";
import mc from "./components/icons/settings.js";
import vc from "./components/icons/share-2.js";
import uc from "./components/icons/share-screen.js";
import pc from "./components/icons/share.js";
import gc from "./components/icons/sheet.js";
import fc from "./components/icons/shield-alert.js";
import bc from "./components/icons/shield-check.js";
import Dc from "./components/icons/shield-close.js";
import Ic from "./components/icons/shield-off.js";
import dc from "./components/icons/shield.js";
import hc from "./components/icons/shortcuts.js";
import kc from "./components/icons/shuffle.js";
import Cc from "./components/icons/sidebar-close.js";
import wc from "./components/icons/sidebar-open.js";
import yc from "./components/icons/sidebar.js";
import Sc from "./components/icons/signal-best.js";
import Mc from "./components/icons/signal-high.js";
import Bc from "./components/icons/signal-low.js";
import Ac from "./components/icons/signal-medium.js";
import Fc from "./components/icons/signal-zero.js";
import Lc from "./components/icons/simultaneous-ring.js";
import Pc from "./components/icons/siren.js";
import Tc from "./components/icons/skip-15-sec.js";
import Rc from "./components/icons/skip-back-ten.js";
import Oc from "./components/icons/skip-back.js";
import xc from "./components/icons/skip-forward-ten.js";
import zc from "./components/icons/skip-forward.js";
import Uc from "./components/icons/slack.js";
import Hc from "./components/icons/slash.js";
import Gc from "./components/icons/sliders-horizontal.js";
import Vc from "./components/icons/sliders.js";
import Wc from "./components/icons/small-self-view.js";
import Ec from "./components/icons/smartphone-charging.js";
import Nc from "./components/icons/smartphone.js";
import qc from "./components/icons/snapchat.js";
import Zc from "./components/icons/snooze.js";
import jc from "./components/icons/snowflake.js";
import Qc from "./components/icons/somewhat-dissatisfied-filled.js";
import Xc from "./components/icons/somewhat-dissatisfied.js";
import Jc from "./components/icons/somewhat-satisfied-filled.js";
import Kc from "./components/icons/somewhat-satisfied.js";
import Yc from "./components/icons/sort-asc.js";
import $c from "./components/icons/sort-desc.js";
import on from "./components/icons/sparkle-filled.js";
import _n from "./components/icons/sparkle.js";
import rn from "./components/icons/speaker.js";
import tn from "./components/icons/star-filled.js";
import sn from "./components/icons/star.js";
import en from "./components/icons/sticker.js";
import cn from "./components/icons/stop-circle-filled.js";
import nn from "./components/icons/stop-circle.js";
import ln from "./components/icons/stop-filled.js";
import an from "./components/icons/strikethrough.js";
import mn from "./components/icons/sun-dim.js";
import vn from "./components/icons/sun-medium.js";
import un from "./components/icons/sun.js";
import pn from "./components/icons/sunrise.js";
import gn from "./components/icons/sunset.js";
import fn from "./components/icons/switch-to-cellular.js";
import bn from "./components/icons/switch-to-hd.js";
import Dn from "./components/icons/t-mobile.js";
import In from "./components/icons/table.js";
import dn from "./components/icons/tag.js";
import hn from "./components/icons/tags.js";
import kn from "./components/icons/takeover.js";
import Cn from "./components/icons/task.js";
import wn from "./components/icons/telegram.js";
import yn from "./components/icons/text-cursor-input.js";
import Sn from "./components/icons/text-cursor.js";
import Mn from "./components/icons/thermometer-snowflake.js";
import Bn from "./components/icons/thermometer-sun.js";
import An from "./components/icons/thermometer.js";
import Fn from "./components/icons/thread.js";
import Ln from "./components/icons/threads.js";
import Pn from "./components/icons/thumbs-down-filled.js";
import Tn from "./components/icons/thumbs-down.js";
import Rn from "./components/icons/thumbs-up-filled.js";
import On from "./components/icons/thumbs-up.js";
import xn from "./components/icons/tiktok.js";
import zn from "./components/icons/timer-off.js";
import Un from "./components/icons/timer-reset.js";
import Hn from "./components/icons/timer.js";
import Gn from "./components/icons/toggl.js";
import Vn from "./components/icons/token.js";
import Wn from "./components/icons/too-many-queries.js";
import En from "./components/icons/tools.js";
import Nn from "./components/icons/toy-brick.js";
import qn from "./components/icons/transfer-webchat.js";
import Zn from "./components/icons/transfer.js";
import jn from "./components/icons/transportation.js";
import Qn from "./components/icons/trash.js";
import Xn from "./components/icons/trending-down.js";
import Jn from "./components/icons/trending-up.js";
import Kn from "./components/icons/triangle.js";
import Yn from "./components/icons/twitter.js";
import $n from "./components/icons/type.js";
import ol from "./components/icons/umbrella.js";
import _l from "./components/icons/underline.js";
import il from "./components/icons/undo-2.js";
import rl from "./components/icons/union-pay.js";
import tl from "./components/icons/unlink-2.js";
import sl from "./components/icons/unlock-filled.js";
import el from "./components/icons/unlock.js";
import cl from "./components/icons/unread.js";
import nl from "./components/icons/upload-cloud.js";
import ll from "./components/icons/upload.js";
import al from "./components/icons/usb.js";
import ml from "./components/icons/user-check.js";
import vl from "./components/icons/user-minus.js";
import ul from "./components/icons/user-plus.js";
import pl from "./components/icons/user-rematch.js";
import gl from "./components/icons/user-remove.js";
import fl from "./components/icons/user-speak.js";
import bl from "./components/icons/user.js";
import Dl from "./components/icons/users.js";
import Il from "./components/icons/very-dissatisfied-filled.js";
import dl from "./components/icons/very-dissatisfied.js";
import hl from "./components/icons/very-satisfied-filled.js";
import kl from "./components/icons/very-satisfied.js";
import Cl from "./components/icons/viber.js";
import wl from "./components/icons/video-off.js";
import yl from "./components/icons/video-settings.js";
import Sl from "./components/icons/video.js";
import Ml from "./components/icons/visa.js";
import Bl from "./components/icons/voicemail-drop.js";
import Al from "./components/icons/voicemail.js";
import Fl from "./components/icons/volume-1.js";
import Ll from "./components/icons/volume-2.js";
import Pl from "./components/icons/volume-x.js";
import Tl from "./components/icons/volume.js";
import Rl from "./components/icons/waveform.js";
import Ol from "./components/icons/we-chat.js";
import xl from "./components/icons/webcam.js";
import zl from "./components/icons/webchat.js";
import Ul from "./components/icons/webex.js";
import Hl from "./components/icons/whatsapp-outlined.js";
import Gl from "./components/icons/whatsapp.js";
import Vl from "./components/icons/whisper.js";
import Wl from "./components/icons/wifi-off.js";
import El from "./components/icons/wifi.js";
import Nl from "./components/icons/wind.js";
import ql from "./components/icons/x-brand.js";
import Zl from "./components/icons/x-circle.js";
import jl from "./components/icons/zap-off.js";
import Ql from "./components/icons/zendesk.js";
import Xl from "./components/icons/zoho-crm.js";
import Jl from "./components/icons/zoho-desk.js";
import Kl from "./components/icons/zoho.js";
import Yl from "./components/icons/zoom-in.js";
import $l from "./components/icons/zoom-logo.js";
import oa from "./components/icons/zoom-out.js";
import _a from "./components/icons/zoom.js";
import ia from "./components/illustrations/access-denied.js";
import ra from "./components/illustrations/atomic-pathway.js";
import ta from "./components/illustrations/black-hole.js";
import sa from "./components/illustrations/blank-space.js";
import ea from "./components/illustrations/browser-table-graph.js";
import ca from "./components/illustrations/dialpad-logo-black.js";
import na from "./components/illustrations/dialpad-logo-inverted.js";
import la from "./components/illustrations/dialpad-logo-white.js";
import aa from "./components/illustrations/dialpad-logo.js";
import ma from "./components/illustrations/dialpad-mono-black.js";
import va from "./components/illustrations/dialpad-mono-inverted.js";
import ua from "./components/illustrations/dialpad-mono-white.js";
import pa from "./components/illustrations/dialpad-mono.js";
import ga from "./components/illustrations/file-upload.js";
import fa from "./components/illustrations/login-error.js";
import ba from "./components/illustrations/magnifier.js";
import Da from "./components/illustrations/mic-detected.js";
import Ia from "./components/illustrations/mind.js";
import da from "./components/illustrations/mobile-full-notifications.js";
import ha from "./components/illustrations/new-meeting.js";
import ka from "./components/illustrations/new-message.js";
import Ca from "./components/illustrations/nothing-to-see-here.js";
import wa from "./components/illustrations/orbital-harmony.js";
import ya from "./components/illustrations/playlist.js";
import Sa from "./components/illustrations/publish-graphic.js";
import Ma from "./components/illustrations/something-went-wrong.js";
import Ba from "./components/illustrations/vector-vortex.js";
import Aa from "./components/illustrations/wireless-screenshare.js";
const sh = /* @__PURE__ */ Object.assign({ "./src/icons/accessibility-mac.vue": o, "./src/icons/accessibility.vue": _, "./src/icons/activity.vue": i, "./src/icons/add-task.vue": r, "./src/icons/agent-assist.vue": t, "./src/icons/ai-notes.vue": s, "./src/icons/ai-write.vue": e, "./src/icons/airplay.vue": c, "./src/icons/airtable.vue": n, "./src/icons/alarm-check.vue": l, "./src/icons/alarm-clock-off.vue": a, "./src/icons/alarm-minus.vue": m, "./src/icons/alarm-plus.vue": v, "./src/icons/album.vue": u, "./src/icons/alert-circle.vue": p, "./src/icons/alert-triangle.vue": g, "./src/icons/align-center.vue": f, "./src/icons/align-justify.vue": b, "./src/icons/align-left.vue": D, "./src/icons/align-right.vue": I, "./src/icons/amex.vue": d, "./src/icons/app-store-badge.vue": h, "./src/icons/apple.vue": k, "./src/icons/archive-restore.vue": C, "./src/icons/archive.vue": w, "./src/icons/arrow-down-left.vue": y, "./src/icons/arrow-down-right.vue": S, "./src/icons/arrow-down.vue": M, "./src/icons/arrow-left-right.vue": B, "./src/icons/arrow-left.vue": A, "./src/icons/arrow-right.vue": F, "./src/icons/arrow-up-down.vue": L, "./src/icons/arrow-up-left.vue": P, "./src/icons/arrow-up-right.vue": T, "./src/icons/arrow-up.vue": R, "./src/icons/asana.vue": O, "./src/icons/asterisk.vue": x, "./src/icons/at-sign.vue": z, "./src/icons/ata-adapter.vue": U, "./src/icons/attestation-outline.vue": H, "./src/icons/attestation.vue": G, "./src/icons/axis-3d.vue": V, "./src/icons/bar-chart-2.vue": W, "./src/icons/bar-chart-3.vue": E, "./src/icons/bar-chart-4.vue": N, "./src/icons/bar-chart-horizontal.vue": q, "./src/icons/bar-chart.vue": Z, "./src/icons/barge.vue": j, "./src/icons/baseline.vue": Q, "./src/icons/battery-charging.vue": X, "./src/icons/battery-full.vue": J, "./src/icons/battery-low.vue": K, "./src/icons/battery-medium.vue": Y, "./src/icons/battery.vue": $, "./src/icons/bell-minus.vue": oo, "./src/icons/bell-off.vue": _o, "./src/icons/bell-plus.vue": io, "./src/icons/bell-ring.vue": ro, "./src/icons/bell.vue": to, "./src/icons/binary.vue": so, "./src/icons/bluetooth-connected.vue": eo, "./src/icons/bluetooth-off.vue": co, "./src/icons/bluetooth-searching.vue": no, "./src/icons/bluetooth.vue": lo, "./src/icons/blur-background.vue": ao, "./src/icons/bold.vue": mo, "./src/icons/book-open.vue": vo, "./src/icons/book.vue": uo, "./src/icons/bookmark-filled.vue": po, "./src/icons/bookmark-minus.vue": go, "./src/icons/bookmark-plus.vue": fo, "./src/icons/bookmark.vue": bo, "./src/icons/box-select.vue": Do, "./src/icons/box.vue": Io, "./src/icons/boxes.vue": ho, "./src/icons/branch.vue": ko, "./src/icons/brand-dialpad-meetings.vue": Co, "./src/icons/brand-dialpad.vue": wo, "./src/icons/breakout-rooms.vue": yo, "./src/icons/briefcase.vue": So, "./src/icons/building-2.vue": Mo, "./src/icons/building.vue": Bo, "./src/icons/bullet.vue": Ao, "./src/icons/bullhorn.vue": Fo, "./src/icons/calculator.vue": Lo, "./src/icons/calendar-check-2.vue": Po, "./src/icons/calendar-check.vue": To, "./src/icons/calendar-clock.vue": Ro, "./src/icons/calendar-days.vue": Oo, "./src/icons/calendar-heart.vue": xo, "./src/icons/calendar-minus.vue": zo, "./src/icons/calendar-off.vue": Uo, "./src/icons/calendar-plus.vue": Ho, "./src/icons/calendar-range.vue": Go, "./src/icons/calendar-search.vue": Vo, "./src/icons/calendar-x.vue": Wo, "./src/icons/calendar.vue": Eo, "./src/icons/call-abandoned.vue": No, "./src/icons/call-merge.vue": qo, "./src/icons/call-rejected.vue": Zo, "./src/icons/camera-off.vue": jo, "./src/icons/camera-tracking.vue": Qo, "./src/icons/camera.vue": Xo, "./src/icons/cast.vue": Jo, "./src/icons/check-circle-filled.vue": Ko, "./src/icons/check-circle.vue": Yo, "./src/icons/check.vue": $o, "./src/icons/chevron-down.vue": o_, "./src/icons/chevron-first.vue": __, "./src/icons/chevron-last.vue": i_, "./src/icons/chevron-left.vue": r_, "./src/icons/chevron-right.vue": t_, "./src/icons/chevron-up.vue": s_, "./src/icons/chevrons-down-up.vue": e_, "./src/icons/chevrons-down.vue": c_, "./src/icons/chevrons-left-right.vue": n_, "./src/icons/chevrons-left.vue": l_, "./src/icons/chevrons-right-left.vue": a_, "./src/icons/chevrons-right.vue": m_, "./src/icons/chevrons-up-down.vue": v_, "./src/icons/chevrons-up.vue": u_, "./src/icons/circle-half-filled.vue": p_, "./src/icons/circle-slashed.vue": g_, "./src/icons/clipboard-check.vue": f_, "./src/icons/clipboard-copy.vue": b_, "./src/icons/clipboard-edit.vue": D_, "./src/icons/clipboard-list.vue": I_, "./src/icons/clipboard-signature.vue": d_, "./src/icons/clipboard-type.vue": h_, "./src/icons/clipboard-x.vue": k_, "./src/icons/clipboard.vue": C_, "./src/icons/clock-1.vue": w_, "./src/icons/clock-10.vue": y_, "./src/icons/clock-11.vue": S_, "./src/icons/clock-12.vue": M_, "./src/icons/clock-2.vue": B_, "./src/icons/clock-3.vue": A_, "./src/icons/clock-4.vue": F_, "./src/icons/clock-5.vue": L_, "./src/icons/clock-6.vue": P_, "./src/icons/clock-7.vue": T_, "./src/icons/clock-8.vue": R_, "./src/icons/clock-9.vue": O_, "./src/icons/clock.vue": x_, "./src/icons/clockify.vue": z_, "./src/icons/close.vue": U_, "./src/icons/cloud-cog.vue": H_, "./src/icons/cloud-drizzle.vue": G_, "./src/icons/cloud-fog.vue": V_, "./src/icons/cloud-hail.vue": W_, "./src/icons/cloud-lightning.vue": E_, "./src/icons/cloud-moon-rain.vue": N_, "./src/icons/cloud-moon.vue": q_, "./src/icons/cloud-off.vue": Z_, "./src/icons/cloud-rain-wind.vue": j_, "./src/icons/cloud-rain.vue": Q_, "./src/icons/cloud-snow.vue": X_, "./src/icons/cloud-sun-rain.vue": J_, "./src/icons/cloud-sun.vue": K_, "./src/icons/cloud.vue": Y_, "./src/icons/cloudy.vue": $_, "./src/icons/coaching-hub.vue": oi, "./src/icons/code-block.vue": _i, "./src/icons/code.vue": ii, "./src/icons/command.vue": ri, "./src/icons/concierge-bell.vue": ti, "./src/icons/connection-api.vue": si, "./src/icons/contacts.vue": ei, "./src/icons/copper-crm.vue": ci, "./src/icons/copy.vue": ni, "./src/icons/copyright.vue": li, "./src/icons/corner-down-left.vue": ai, "./src/icons/corner-down-right.vue": mi, "./src/icons/corner-left-down.vue": vi, "./src/icons/corner-left-up.vue": ui, "./src/icons/corner-right-down.vue": pi, "./src/icons/corner-right-up.vue": gi, "./src/icons/corner-up-left.vue": fi, "./src/icons/corner-up-right.vue": bi, "./src/icons/cpu.vue": Di, "./src/icons/credit-card.vue": Ii, "./src/icons/dash.vue": di, "./src/icons/dect-base-station.vue": hi, "./src/icons/dect-handset.vue": ki, "./src/icons/default-ai-agent-fab.vue": Ci, "./src/icons/delete.vue": wi, "./src/icons/deskphone.vue": yi, "./src/icons/dialbot.vue": Si, "./src/icons/dialer.vue": Mi, "./src/icons/dialpad-ai-color-reversed.vue": Bi, "./src/icons/dialpad-ai-color.vue": Ai, "./src/icons/dialpad-ai-reversed.vue": Fi, "./src/icons/dialpad-ai.vue": Li, "./src/icons/dialpad-analytics-ai.vue": Pi, "./src/icons/dialpad-logo.vue": Ti, "./src/icons/dialpad-logomark.vue": Ri, "./src/icons/dialpad-meetings-star.vue": Oi, "./src/icons/dialpad-sparkle.vue": xi, "./src/icons/dialpad-star-mark-color.vue": zi, "./src/icons/dialpad-star-mark.vue": Ui, "./src/icons/dialpad-star-reversed.vue": Hi, "./src/icons/dialpad-star.vue": Gi, "./src/icons/dialpad-wfm.vue": Vi, "./src/icons/digital-whisper.vue": Wi, "./src/icons/diners-club.vue": Ei, "./src/icons/discover.vue": Ni, "./src/icons/dissatisfied-filled.vue": qi, "./src/icons/dissatisfied.vue": Zi, "./src/icons/double-check.vue": ji, "./src/icons/download-cloud.vue": Qi, "./src/icons/download.vue": Xi, "./src/icons/dp-phone.vue": Ji, "./src/icons/dpm-logo.vue": Ki, "./src/icons/edit-2.vue": Yi, "./src/icons/edit.vue": $i, "./src/icons/empty.vue": or, "./src/icons/end-chat.vue": _r, "./src/icons/equal.vue": ir, "./src/icons/eraser.vue": rr, "./src/icons/evernote.vue": tr, "./src/icons/expand.vue": sr, "./src/icons/expert-node.vue": er, "./src/icons/external-link.vue": cr, "./src/icons/eye-off.vue": nr, "./src/icons/eye.vue": lr, "./src/icons/facebook.vue": ar, "./src/icons/factory.vue": mr, "./src/icons/fast-forward.vue": vr, "./src/icons/file-audio.vue": ur, "./src/icons/file-pdf.vue": pr, "./src/icons/file.vue": gr, "./src/icons/files.vue": fr, "./src/icons/film.vue": br, "./src/icons/filter.vue": Dr, "./src/icons/fingerprint.vue": Ir, "./src/icons/flag-off.vue": dr, "./src/icons/flag.vue": hr, "./src/icons/flame.vue": kr, "./src/icons/focus.vue": Cr, "./src/icons/folder-tree.vue": wr, "./src/icons/folder.vue": yr, "./src/icons/folders.vue": Sr, "./src/icons/food.vue": Mr, "./src/icons/form-input.vue": Br, "./src/icons/forward.vue": Ar, "./src/icons/freshdesk.vue": Fr, "./src/icons/freshsales-crm.vue": Lr, "./src/icons/front.vue": Pr, "./src/icons/gamepad.vue": Tr, "./src/icons/gauge.vue": Rr, "./src/icons/gif-filled.vue": Or, "./src/icons/gif-outline.vue": xr, "./src/icons/giphy.vue": zr, "./src/icons/globe-2.vue": Ur, "./src/icons/gmail.vue": Hr, "./src/icons/google-business-messaging.vue": Gr, "./src/icons/google-calendar.vue": Vr, "./src/icons/google-docs.vue": Wr, "./src/icons/google-drive.vue": Er, "./src/icons/google-glyph.vue": Nr, "./src/icons/google-meet.vue": qr, "./src/icons/google-sheets.vue": Zr, "./src/icons/google-slides.vue": jr, "./src/icons/graduation.vue": Qr, "./src/icons/greenhouse.vue": Xr, "./src/icons/grid.vue": Jr, "./src/icons/grip-horizontal.vue": Kr, "./src/icons/grip-vertical.vue": Yr, "./src/icons/hand.vue": $r, "./src/icons/hard-drive.vue": ot, "./src/icons/hash-bold.vue": _t, "./src/icons/hash.vue": it, "./src/icons/haze.vue": rt, "./src/icons/hd.vue": tt, "./src/icons/headphones.vue": st, "./src/icons/headset.vue": et, "./src/icons/hear.vue": ct, "./src/icons/heart.vue": nt, "./src/icons/help-circle.vue": lt, "./src/icons/highfive.vue": at, "./src/icons/history.vue": mt, "./src/icons/hold.vue": vt, "./src/icons/home.vue": ut, "./src/icons/hourglass.vue": pt, "./src/icons/hubspot.vue": gt, "./src/icons/image.vue": ft, "./src/icons/import.vue": bt, "./src/icons/inbox.vue": Dt, "./src/icons/indent.vue": It, "./src/icons/infinity.vue": dt, "./src/icons/info.vue": ht, "./src/icons/inspect.vue": kt, "./src/icons/instagram.vue": Ct, "./src/icons/intercom.vue": wt, "./src/icons/isolated-queries.vue": yt, "./src/icons/italic.vue": St, "./src/icons/jcb.vue": Mt, "./src/icons/jira-service-desk.vue": Bt, "./src/icons/key.vue": At, "./src/icons/keyboard.vue": Ft, "./src/icons/keypad.vue": Lt, "./src/icons/languages.vue": Pt, "./src/icons/laptop-2.vue": Tt, "./src/icons/large-self-view.vue": Rt, "./src/icons/layout-dashboard.vue": Ot, "./src/icons/layout-filmstrip.vue": xt, "./src/icons/layout-grid.vue": zt, "./src/icons/layout-template.vue": Ut, "./src/icons/layout.vue": Ht, "./src/icons/library.vue": Gt, "./src/icons/life-buoy.vue": Vt, "./src/icons/lightbulb-off.vue": Wt, "./src/icons/lightbulb.vue": Et, "./src/icons/lightning-bolt.vue": Nt, "./src/icons/line-chart.vue": qt, "./src/icons/line-messenger.vue": Zt, "./src/icons/link-2-off.vue": jt, "./src/icons/link-2.vue": Qt, "./src/icons/linkedin.vue": Xt, "./src/icons/list-add.vue": Jt, "./src/icons/list-bullet.vue": Kt, "./src/icons/list-checks.vue": Yt, "./src/icons/list-ordered.vue": $t, "./src/icons/listen.vue": os, "./src/icons/listening.vue": _s, "./src/icons/live-queue.vue": is, "./src/icons/living-thing.vue": rs, "./src/icons/loading.vue": ts, "./src/icons/lock-filled.vue": ss, "./src/icons/lock.vue": es, "./src/icons/log-in.vue": cs, "./src/icons/log-out.vue": ns, "./src/icons/maestro.vue": ls, "./src/icons/mail-open.vue": as, "./src/icons/mail.vue": ms, "./src/icons/mails.vue": vs, "./src/icons/map-pin-filled.vue": us, "./src/icons/map-pin.vue": ps, "./src/icons/map.vue": gs, "./src/icons/mastercard.vue": fs, "./src/icons/maximize.vue": bs, "./src/icons/megaphone-off.vue": Ds, "./src/icons/megaphone.vue": Is, "./src/icons/menu.vue": ds, "./src/icons/message.vue": hs, "./src/icons/messenger.vue": ks, "./src/icons/mic-off.vue": Cs, "./src/icons/mic.vue": ws, "./src/icons/microsoft-dynamics-365.vue": ys, "./src/icons/microsoft-teams.vue": Ss, "./src/icons/microsoft.vue": Ms, "./src/icons/minimize-alt.vue": Bs, "./src/icons/minimize.vue": As, "./src/icons/minus-circle.vue": Fs, "./src/icons/miro.vue": Ls, "./src/icons/monday-com.vue": Ps, "./src/icons/monitor-off.vue": Ts, "./src/icons/monitor-speaker.vue": Rs, "./src/icons/monitor.vue": Os, "./src/icons/moon.vue": xs, "./src/icons/more-horizontal.vue": zs, "./src/icons/more-vertical.vue": Us, "./src/icons/mouse.vue": Hs, "./src/icons/multi-line-dept.vue": Gs, "./src/icons/music-off.vue": Vs, "./src/icons/music.vue": Ws, "./src/icons/network.vue": Es, "./src/icons/neutral.vue": Ns, "./src/icons/newspaper.vue": qs, "./src/icons/not-enough-queries.vue": Zs, "./src/icons/notes.vue": js, "./src/icons/o365-calendar.vue": Qs, "./src/icons/object.vue": Xs, "./src/icons/office-365.vue": Js, "./src/icons/option.vue": Ks, "./src/icons/package.vue": Ys, "./src/icons/paperclip.vue": $s, "./src/icons/park.vue": oe, "./src/icons/party-popper.vue": _e, "./src/icons/past-conversations.vue": ie, "./src/icons/pause-circle-filled.vue": re, "./src/icons/pause-circle.vue": te, "./src/icons/pause.vue": se, "./src/icons/phone-call.vue": ee, "./src/icons/phone-forward.vue": ce, "./src/icons/phone-hang-up.vue": ne, "./src/icons/phone-hold.vue": le, "./src/icons/phone-incoming.vue": ae, "./src/icons/phone-missed.vue": me, "./src/icons/phone-off.vue": ve, "./src/icons/phone-outgoing.vue": ue, "./src/icons/phone.vue": pe, "./src/icons/picture-in-picture.vue": ge, "./src/icons/pie-chart.vue": fe, "./src/icons/pin-filled.vue": be, "./src/icons/pin-off.vue": De, "./src/icons/pin.vue": Ie, "./src/icons/pipedrive.vue": de, "./src/icons/play-circle-filled.vue": he, "./src/icons/play-circle.vue": ke, "./src/icons/play-filled.vue": Ce, "./src/icons/play-store-badge.vue": we, "./src/icons/play.vue": ye, "./src/icons/plug.vue": Se, "./src/icons/plus-circle-filled.vue": Me, "./src/icons/plus-circle.vue": Be, "./src/icons/plus.vue": Ae, "./src/icons/power-dialer-off.vue": Fe, "./src/icons/power-dialer.vue": Le, "./src/icons/power.vue": Pe, "./src/icons/print-fax.vue": Te, "./src/icons/printer.vue": Re, "./src/icons/puzzle.vue": Oe, "./src/icons/qr-code.vue": xe, "./src/icons/queries.vue": ze, "./src/icons/quick-reply.vue": Ue, "./src/icons/quote.vue": He, "./src/icons/record-filled.vue": Ge, "./src/icons/record.vue": Ve, "./src/icons/redo.vue": We, "./src/icons/refresh.vue": Ee, "./src/icons/rematch.vue": Ne, "./src/icons/repeat.vue": qe, "./src/icons/reply-all.vue": Ze, "./src/icons/reply.vue": je, "./src/icons/rewind-15-sec.vue": Qe, "./src/icons/rewind.vue": Xe, "./src/icons/rocket.vue": Je, "./src/icons/salesforce-glyph.vue": Ke, "./src/icons/salesforce-logo.vue": Ye, "./src/icons/satisfied-filled.vue": $e, "./src/icons/satisfied.vue": oc, "./src/icons/save.vue": _c, "./src/icons/scan-face.vue": ic, "./src/icons/scan-file.vue": rc, "./src/icons/scan.vue": tc, "./src/icons/scissors.vue": sc, "./src/icons/screen-share-off.vue": ec, "./src/icons/scroll.vue": cc, "./src/icons/search.vue": nc, "./src/icons/send.vue": lc, "./src/icons/servicenow.vue": ac, "./src/icons/settings.vue": mc, "./src/icons/share-2.vue": vc, "./src/icons/share-screen.vue": uc, "./src/icons/share.vue": pc, "./src/icons/sheet.vue": gc, "./src/icons/shield-alert.vue": fc, "./src/icons/shield-check.vue": bc, "./src/icons/shield-close.vue": Dc, "./src/icons/shield-off.vue": Ic, "./src/icons/shield.vue": dc, "./src/icons/shortcuts.vue": hc, "./src/icons/shuffle.vue": kc, "./src/icons/sidebar-close.vue": Cc, "./src/icons/sidebar-open.vue": wc, "./src/icons/sidebar.vue": yc, "./src/icons/signal-best.vue": Sc, "./src/icons/signal-high.vue": Mc, "./src/icons/signal-low.vue": Bc, "./src/icons/signal-medium.vue": Ac, "./src/icons/signal-zero.vue": Fc, "./src/icons/simultaneous-ring.vue": Lc, "./src/icons/siren.vue": Pc, "./src/icons/skip-15-sec.vue": Tc, "./src/icons/skip-back-ten.vue": Rc, "./src/icons/skip-back.vue": Oc, "./src/icons/skip-forward-ten.vue": xc, "./src/icons/skip-forward.vue": zc, "./src/icons/slack.vue": Uc, "./src/icons/slash.vue": Hc, "./src/icons/sliders-horizontal.vue": Gc, "./src/icons/sliders.vue": Vc, "./src/icons/small-self-view.vue": Wc, "./src/icons/smartphone-charging.vue": Ec, "./src/icons/smartphone.vue": Nc, "./src/icons/snapchat.vue": qc, "./src/icons/snooze.vue": Zc, "./src/icons/snowflake.vue": jc, "./src/icons/somewhat-dissatisfied-filled.vue": Qc, "./src/icons/somewhat-dissatisfied.vue": Xc, "./src/icons/somewhat-satisfied-filled.vue": Jc, "./src/icons/somewhat-satisfied.vue": Kc, "./src/icons/sort-asc.vue": Yc, "./src/icons/sort-desc.vue": $c, "./src/icons/sparkle-filled.vue": on, "./src/icons/sparkle.vue": _n, "./src/icons/speaker.vue": rn, "./src/icons/star-filled.vue": tn, "./src/icons/star.vue": sn, "./src/icons/sticker.vue": en, "./src/icons/stop-circle-filled.vue": cn, "./src/icons/stop-circle.vue": nn, "./src/icons/stop-filled.vue": ln, "./src/icons/strikethrough.vue": an, "./src/icons/sun-dim.vue": mn, "./src/icons/sun-medium.vue": vn, "./src/icons/sun.vue": un, "./src/icons/sunrise.vue": pn, "./src/icons/sunset.vue": gn, "./src/icons/switch-to-cellular.vue": fn, "./src/icons/switch-to-hd.vue": bn, "./src/icons/t-mobile.vue": Dn, "./src/icons/table.vue": In, "./src/icons/tag.vue": dn, "./src/icons/tags.vue": hn, "./src/icons/takeover.vue": kn, "./src/icons/task.vue": Cn, "./src/icons/telegram.vue": wn, "./src/icons/text-cursor-input.vue": yn, "./src/icons/text-cursor.vue": Sn, "./src/icons/thermometer-snowflake.vue": Mn, "./src/icons/thermometer-sun.vue": Bn, "./src/icons/thermometer.vue": An, "./src/icons/thread.vue": Fn, "./src/icons/threads.vue": Ln, "./src/icons/thumbs-down-filled.vue": Pn, "./src/icons/thumbs-down.vue": Tn, "./src/icons/thumbs-up-filled.vue": Rn, "./src/icons/thumbs-up.vue": On, "./src/icons/tiktok.vue": xn, "./src/icons/timer-off.vue": zn, "./src/icons/timer-reset.vue": Un, "./src/icons/timer.vue": Hn, "./src/icons/toggl.vue": Gn, "./src/icons/token.vue": Vn, "./src/icons/too-many-queries.vue": Wn, "./src/icons/tools.vue": En, "./src/icons/toy-brick.vue": Nn, "./src/icons/transfer-webchat.vue": qn, "./src/icons/transfer.vue": Zn, "./src/icons/transportation.vue": jn, "./src/icons/trash.vue": Qn, "./src/icons/trending-down.vue": Xn, "./src/icons/trending-up.vue": Jn, "./src/icons/triangle.vue": Kn, "./src/icons/twitter.vue": Yn, "./src/icons/type.vue": $n, "./src/icons/umbrella.vue": ol, "./src/icons/underline.vue": _l, "./src/icons/undo-2.vue": il, "./src/icons/union-pay.vue": rl, "./src/icons/unlink-2.vue": tl, "./src/icons/unlock-filled.vue": sl, "./src/icons/unlock.vue": el, "./src/icons/unread.vue": cl, "./src/icons/upload-cloud.vue": nl, "./src/icons/upload.vue": ll, "./src/icons/usb.vue": al, "./src/icons/user-check.vue": ml, "./src/icons/user-minus.vue": vl, "./src/icons/user-plus.vue": ul, "./src/icons/user-rematch.vue": pl, "./src/icons/user-remove.vue": gl, "./src/icons/user-speak.vue": fl, "./src/icons/user.vue": bl, "./src/icons/users.vue": Dl, "./src/icons/very-dissatisfied-filled.vue": Il, "./src/icons/very-dissatisfied.vue": dl, "./src/icons/very-satisfied-filled.vue": hl, "./src/icons/very-satisfied.vue": kl, "./src/icons/viber.vue": Cl, "./src/icons/video-off.vue": wl, "./src/icons/video-settings.vue": yl, "./src/icons/video.vue": Sl, "./src/icons/visa.vue": Ml, "./src/icons/voicemail-drop.vue": Bl, "./src/icons/voicemail.vue": Al, "./src/icons/volume-1.vue": Fl, "./src/icons/volume-2.vue": Ll, "./src/icons/volume-x.vue": Pl, "./src/icons/volume.vue": Tl, "./src/icons/waveform.vue": Rl, "./src/icons/we-chat.vue": Ol, "./src/icons/webcam.vue": xl, "./src/icons/webchat.vue": zl, "./src/icons/webex.vue": Ul, "./src/icons/whatsapp-outlined.vue": Hl, "./src/icons/whatsapp.vue": Gl, "./src/icons/whisper.vue": Vl, "./src/icons/wifi-off.vue": Wl, "./src/icons/wifi.vue": El, "./src/icons/wind.vue": Nl, "./src/icons/x-brand.vue": ql, "./src/icons/x-circle.vue": Zl, "./src/icons/zap-off.vue": jl, "./src/icons/zendesk.vue": Ql, "./src/icons/zoho-crm.vue": Xl, "./src/icons/zoho-desk.vue": Jl, "./src/icons/zoho.vue": Kl, "./src/icons/zoom-in.vue": Yl, "./src/icons/zoom-logo.vue": $l, "./src/icons/zoom-out.vue": oa, "./src/icons/zoom.vue": _a }), eh = /* @__PURE__ */ Object.assign({ "./src/illustrations/access-denied.vue": ia, "./src/illustrations/atomic-pathway.vue": ra, "./src/illustrations/black-hole.vue": ta, "./src/illustrations/blank-space.vue": sa, "./src/illustrations/browser-table-graph.vue": ea, "./src/illustrations/dialpad-logo-black.vue": ca, "./src/illustrations/dialpad-logo-inverted.vue": na, "./src/illustrations/dialpad-logo-white.vue": la, "./src/illustrations/dialpad-logo.vue": aa, "./src/illustrations/dialpad-mono-black.vue": ma, "./src/illustrations/dialpad-mono-inverted.vue": va, "./src/illustrations/dialpad-mono-white.vue": ua, "./src/illustrations/dialpad-mono.vue": pa, "./src/illustrations/file-upload.vue": ga, "./src/illustrations/login-error.vue": fa, "./src/illustrations/magnifier.vue": ba, "./src/illustrations/mic-detected.vue": Da, "./src/illustrations/mind.vue": Ia, "./src/illustrations/mobile-full-notifications.vue": da, "./src/illustrations/new-meeting.vue": ha, "./src/illustrations/new-message.vue": ka, "./src/illustrations/nothing-to-see-here.vue": Ca, "./src/illustrations/orbital-harmony.vue": wa, "./src/illustrations/playlist.vue": ya, "./src/illustrations/publish-graphic.vue": Sa, "./src/illustrations/something-went-wrong.vue": Ma, "./src/illustrations/vector-vortex.vue": Ba, "./src/illustrations/wireless-screenshare.vue": Aa });
export {
  _ as DtIconAccessibility,
  o as DtIconAccessibilityMac,
  i as DtIconActivity,
  r as DtIconAddTask,
  t as DtIconAgentAssist,
  s as DtIconAiNotes,
  e as DtIconAiWrite,
  c as DtIconAirplay,
  n as DtIconAirtable,
  l as DtIconAlarmCheck,
  a as DtIconAlarmClockOff,
  m as DtIconAlarmMinus,
  v as DtIconAlarmPlus,
  u as DtIconAlbum,
  p as DtIconAlertCircle,
  g as DtIconAlertTriangle,
  f as DtIconAlignCenter,
  b as DtIconAlignJustify,
  D as DtIconAlignLeft,
  I as DtIconAlignRight,
  d as DtIconAmex,
  h as DtIconAppStoreBadge,
  k as DtIconApple,
  w as DtIconArchive,
  C as DtIconArchiveRestore,
  M as DtIconArrowDown,
  y as DtIconArrowDownLeft,
  S as DtIconArrowDownRight,
  A as DtIconArrowLeft,
  B as DtIconArrowLeftRight,
  F as DtIconArrowRight,
  R as DtIconArrowUp,
  L as DtIconArrowUpDown,
  P as DtIconArrowUpLeft,
  T as DtIconArrowUpRight,
  O as DtIconAsana,
  x as DtIconAsterisk,
  z as DtIconAtSign,
  U as DtIconAtaAdapter,
  G as DtIconAttestation,
  H as DtIconAttestationOutline,
  V as DtIconAxis3d,
  Z as DtIconBarChart,
  W as DtIconBarChart2,
  E as DtIconBarChart3,
  N as DtIconBarChart4,
  q as DtIconBarChartHorizontal,
  j as DtIconBarge,
  Q as DtIconBaseline,
  $ as DtIconBattery,
  X as DtIconBatteryCharging,
  J as DtIconBatteryFull,
  K as DtIconBatteryLow,
  Y as DtIconBatteryMedium,
  to as DtIconBell,
  oo as DtIconBellMinus,
  _o as DtIconBellOff,
  io as DtIconBellPlus,
  ro as DtIconBellRing,
  so as DtIconBinary,
  lo as DtIconBluetooth,
  eo as DtIconBluetoothConnected,
  co as DtIconBluetoothOff,
  no as DtIconBluetoothSearching,
  ao as DtIconBlurBackground,
  mo as DtIconBold,
  uo as DtIconBook,
  vo as DtIconBookOpen,
  bo as DtIconBookmark,
  po as DtIconBookmarkFilled,
  go as DtIconBookmarkMinus,
  fo as DtIconBookmarkPlus,
  Io as DtIconBox,
  Do as DtIconBoxSelect,
  ho as DtIconBoxes,
  ko as DtIconBranch,
  wo as DtIconBrandDialpad,
  Co as DtIconBrandDialpadMeetings,
  yo as DtIconBreakoutRooms,
  So as DtIconBriefcase,
  Bo as DtIconBuilding,
  Mo as DtIconBuilding2,
  Ao as DtIconBullet,
  Fo as DtIconBullhorn,
  Lo as DtIconCalculator,
  Eo as DtIconCalendar,
  To as DtIconCalendarCheck,
  Po as DtIconCalendarCheck2,
  Ro as DtIconCalendarClock,
  Oo as DtIconCalendarDays,
  xo as DtIconCalendarHeart,
  zo as DtIconCalendarMinus,
  Uo as DtIconCalendarOff,
  Ho as DtIconCalendarPlus,
  Go as DtIconCalendarRange,
  Vo as DtIconCalendarSearch,
  Wo as DtIconCalendarX,
  No as DtIconCallAbandoned,
  qo as DtIconCallMerge,
  Zo as DtIconCallRejected,
  Xo as DtIconCamera,
  jo as DtIconCameraOff,
  Qo as DtIconCameraTracking,
  Jo as DtIconCast,
  $o as DtIconCheck,
  Yo as DtIconCheckCircle,
  Ko as DtIconCheckCircleFilled,
  o_ as DtIconChevronDown,
  __ as DtIconChevronFirst,
  i_ as DtIconChevronLast,
  r_ as DtIconChevronLeft,
  t_ as DtIconChevronRight,
  s_ as DtIconChevronUp,
  c_ as DtIconChevronsDown,
  e_ as DtIconChevronsDownUp,
  l_ as DtIconChevronsLeft,
  n_ as DtIconChevronsLeftRight,
  m_ as DtIconChevronsRight,
  a_ as DtIconChevronsRightLeft,
  u_ as DtIconChevronsUp,
  v_ as DtIconChevronsUpDown,
  p_ as DtIconCircleHalfFilled,
  g_ as DtIconCircleSlashed,
  C_ as DtIconClipboard,
  f_ as DtIconClipboardCheck,
  b_ as DtIconClipboardCopy,
  D_ as DtIconClipboardEdit,
  I_ as DtIconClipboardList,
  d_ as DtIconClipboardSignature,
  h_ as DtIconClipboardType,
  k_ as DtIconClipboardX,
  x_ as DtIconClock,
  w_ as DtIconClock1,
  y_ as DtIconClock10,
  S_ as DtIconClock11,
  M_ as DtIconClock12,
  B_ as DtIconClock2,
  A_ as DtIconClock3,
  F_ as DtIconClock4,
  L_ as DtIconClock5,
  P_ as DtIconClock6,
  T_ as DtIconClock7,
  R_ as DtIconClock8,
  O_ as DtIconClock9,
  z_ as DtIconClockify,
  U_ as DtIconClose,
  Y_ as DtIconCloud,
  H_ as DtIconCloudCog,
  G_ as DtIconCloudDrizzle,
  V_ as DtIconCloudFog,
  W_ as DtIconCloudHail,
  E_ as DtIconCloudLightning,
  q_ as DtIconCloudMoon,
  N_ as DtIconCloudMoonRain,
  Z_ as DtIconCloudOff,
  Q_ as DtIconCloudRain,
  j_ as DtIconCloudRainWind,
  X_ as DtIconCloudSnow,
  K_ as DtIconCloudSun,
  J_ as DtIconCloudSunRain,
  $_ as DtIconCloudy,
  oi as DtIconCoachingHub,
  ii as DtIconCode,
  _i as DtIconCodeBlock,
  ri as DtIconCommand,
  ti as DtIconConciergeBell,
  si as DtIconConnectionApi,
  ei as DtIconContacts,
  ci as DtIconCopperCrm,
  ni as DtIconCopy,
  li as DtIconCopyright,
  ai as DtIconCornerDownLeft,
  mi as DtIconCornerDownRight,
  vi as DtIconCornerLeftDown,
  ui as DtIconCornerLeftUp,
  pi as DtIconCornerRightDown,
  gi as DtIconCornerRightUp,
  fi as DtIconCornerUpLeft,
  bi as DtIconCornerUpRight,
  Di as DtIconCpu,
  Ii as DtIconCreditCard,
  di as DtIconDash,
  hi as DtIconDectBaseStation,
  ki as DtIconDectHandset,
  Ci as DtIconDefaultAiAgentFab,
  wi as DtIconDelete,
  yi as DtIconDeskphone,
  Si as DtIconDialbot,
  Mi as DtIconDialer,
  Li as DtIconDialpadAi,
  Ai as DtIconDialpadAiColor,
  Bi as DtIconDialpadAiColorReversed,
  Fi as DtIconDialpadAiReversed,
  Pi as DtIconDialpadAnalyticsAi,
  Ti as DtIconDialpadLogo,
  Ri as DtIconDialpadLogomark,
  Oi as DtIconDialpadMeetingsStar,
  xi as DtIconDialpadSparkle,
  Gi as DtIconDialpadStar,
  Ui as DtIconDialpadStarMark,
  zi as DtIconDialpadStarMarkColor,
  Hi as DtIconDialpadStarReversed,
  Vi as DtIconDialpadWfm,
  Wi as DtIconDigitalWhisper,
  Ei as DtIconDinersClub,
  Ni as DtIconDiscover,
  Zi as DtIconDissatisfied,
  qi as DtIconDissatisfiedFilled,
  ji as DtIconDoubleCheck,
  Xi as DtIconDownload,
  Qi as DtIconDownloadCloud,
  Ji as DtIconDpPhone,
  Ki as DtIconDpmLogo,
  $i as DtIconEdit,
  Yi as DtIconEdit2,
  or as DtIconEmpty,
  _r as DtIconEndChat,
  ir as DtIconEqual,
  rr as DtIconEraser,
  tr as DtIconEvernote,
  sr as DtIconExpand,
  er as DtIconExpertNode,
  cr as DtIconExternalLink,
  lr as DtIconEye,
  nr as DtIconEyeOff,
  ar as DtIconFacebook,
  mr as DtIconFactory,
  vr as DtIconFastForward,
  gr as DtIconFile,
  ur as DtIconFileAudio,
  pr as DtIconFilePdf,
  fr as DtIconFiles,
  br as DtIconFilm,
  Dr as DtIconFilter,
  Ir as DtIconFingerprint,
  hr as DtIconFlag,
  dr as DtIconFlagOff,
  kr as DtIconFlame,
  Cr as DtIconFocus,
  yr as DtIconFolder,
  wr as DtIconFolderTree,
  Sr as DtIconFolders,
  Mr as DtIconFood,
  Br as DtIconFormInput,
  Ar as DtIconForward,
  Fr as DtIconFreshdesk,
  Lr as DtIconFreshsalesCrm,
  Pr as DtIconFront,
  Tr as DtIconGamepad,
  Rr as DtIconGauge,
  Or as DtIconGifFilled,
  xr as DtIconGifOutline,
  zr as DtIconGiphy,
  Ur as DtIconGlobe2,
  Hr as DtIconGmail,
  Gr as DtIconGoogleBusinessMessaging,
  Vr as DtIconGoogleCalendar,
  Wr as DtIconGoogleDocs,
  Er as DtIconGoogleDrive,
  Nr as DtIconGoogleGlyph,
  qr as DtIconGoogleMeet,
  Zr as DtIconGoogleSheets,
  jr as DtIconGoogleSlides,
  Qr as DtIconGraduation,
  Xr as DtIconGreenhouse,
  Jr as DtIconGrid,
  Kr as DtIconGripHorizontal,
  Yr as DtIconGripVertical,
  $r as DtIconHand,
  ot as DtIconHardDrive,
  it as DtIconHash,
  _t as DtIconHashBold,
  rt as DtIconHaze,
  tt as DtIconHd,
  st as DtIconHeadphones,
  et as DtIconHeadset,
  ct as DtIconHear,
  nt as DtIconHeart,
  lt as DtIconHelpCircle,
  at as DtIconHighfive,
  mt as DtIconHistory,
  vt as DtIconHold,
  ut as DtIconHome,
  pt as DtIconHourglass,
  gt as DtIconHubspot,
  ft as DtIconImage,
  bt as DtIconImport,
  Dt as DtIconInbox,
  It as DtIconIndent,
  dt as DtIconInfinity,
  ht as DtIconInfo,
  kt as DtIconInspect,
  Ct as DtIconInstagram,
  wt as DtIconIntercom,
  yt as DtIconIsolatedQueries,
  St as DtIconItalic,
  Mt as DtIconJcb,
  Bt as DtIconJiraServiceDesk,
  At as DtIconKey,
  Ft as DtIconKeyboard,
  Lt as DtIconKeypad,
  Pt as DtIconLanguages,
  Tt as DtIconLaptop2,
  Rt as DtIconLargeSelfView,
  Ht as DtIconLayout,
  Ot as DtIconLayoutDashboard,
  xt as DtIconLayoutFilmstrip,
  zt as DtIconLayoutGrid,
  Ut as DtIconLayoutTemplate,
  Gt as DtIconLibrary,
  Vt as DtIconLifeBuoy,
  Et as DtIconLightbulb,
  Wt as DtIconLightbulbOff,
  Nt as DtIconLightningBolt,
  qt as DtIconLineChart,
  Zt as DtIconLineMessenger,
  Qt as DtIconLink2,
  jt as DtIconLink2Off,
  Xt as DtIconLinkedin,
  Jt as DtIconListAdd,
  Kt as DtIconListBullet,
  Yt as DtIconListChecks,
  $t as DtIconListOrdered,
  os as DtIconListen,
  _s as DtIconListening,
  is as DtIconLiveQueue,
  rs as DtIconLivingThing,
  ts as DtIconLoading,
  es as DtIconLock,
  ss as DtIconLockFilled,
  cs as DtIconLogIn,
  ns as DtIconLogOut,
  ls as DtIconMaestro,
  ms as DtIconMail,
  as as DtIconMailOpen,
  vs as DtIconMails,
  gs as DtIconMap,
  ps as DtIconMapPin,
  us as DtIconMapPinFilled,
  fs as DtIconMastercard,
  bs as DtIconMaximize,
  Is as DtIconMegaphone,
  Ds as DtIconMegaphoneOff,
  ds as DtIconMenu,
  hs as DtIconMessage,
  ks as DtIconMessenger,
  ws as DtIconMic,
  Cs as DtIconMicOff,
  Ms as DtIconMicrosoft,
  ys as DtIconMicrosoftDynamics365,
  Ss as DtIconMicrosoftTeams,
  As as DtIconMinimize,
  Bs as DtIconMinimizeAlt,
  Fs as DtIconMinusCircle,
  Ls as DtIconMiro,
  Ps as DtIconMondayCom,
  Os as DtIconMonitor,
  Ts as DtIconMonitorOff,
  Rs as DtIconMonitorSpeaker,
  xs as DtIconMoon,
  zs as DtIconMoreHorizontal,
  Us as DtIconMoreVertical,
  Hs as DtIconMouse,
  Gs as DtIconMultiLineDept,
  Ws as DtIconMusic,
  Vs as DtIconMusicOff,
  Es as DtIconNetwork,
  Ns as DtIconNeutral,
  qs as DtIconNewspaper,
  Zs as DtIconNotEnoughQueries,
  js as DtIconNotes,
  Qs as DtIconO365Calendar,
  Xs as DtIconObject,
  Js as DtIconOffice365,
  Ks as DtIconOption,
  Ys as DtIconPackage,
  $s as DtIconPaperclip,
  oe as DtIconPark,
  _e as DtIconPartyPopper,
  ie as DtIconPastConversations,
  se as DtIconPause,
  te as DtIconPauseCircle,
  re as DtIconPauseCircleFilled,
  pe as DtIconPhone,
  ee as DtIconPhoneCall,
  ce as DtIconPhoneForward,
  ne as DtIconPhoneHangUp,
  le as DtIconPhoneHold,
  ae as DtIconPhoneIncoming,
  me as DtIconPhoneMissed,
  ve as DtIconPhoneOff,
  ue as DtIconPhoneOutgoing,
  ge as DtIconPictureInPicture,
  fe as DtIconPieChart,
  Ie as DtIconPin,
  be as DtIconPinFilled,
  De as DtIconPinOff,
  de as DtIconPipedrive,
  ye as DtIconPlay,
  ke as DtIconPlayCircle,
  he as DtIconPlayCircleFilled,
  Ce as DtIconPlayFilled,
  we as DtIconPlayStoreBadge,
  Se as DtIconPlug,
  Ae as DtIconPlus,
  Be as DtIconPlusCircle,
  Me as DtIconPlusCircleFilled,
  Pe as DtIconPower,
  Le as DtIconPowerDialer,
  Fe as DtIconPowerDialerOff,
  Te as DtIconPrintFax,
  Re as DtIconPrinter,
  Oe as DtIconPuzzle,
  xe as DtIconQrCode,
  ze as DtIconQueries,
  Ue as DtIconQuickReply,
  He as DtIconQuote,
  Ve as DtIconRecord,
  Ge as DtIconRecordFilled,
  We as DtIconRedo,
  Ee as DtIconRefresh,
  Ne as DtIconRematch,
  qe as DtIconRepeat,
  je as DtIconReply,
  Ze as DtIconReplyAll,
  Xe as DtIconRewind,
  Qe as DtIconRewind15Sec,
  Je as DtIconRocket,
  Ke as DtIconSalesforceGlyph,
  Ye as DtIconSalesforceLogo,
  oc as DtIconSatisfied,
  $e as DtIconSatisfiedFilled,
  _c as DtIconSave,
  tc as DtIconScan,
  ic as DtIconScanFace,
  rc as DtIconScanFile,
  sc as DtIconScissors,
  ec as DtIconScreenShareOff,
  cc as DtIconScroll,
  nc as DtIconSearch,
  lc as DtIconSend,
  ac as DtIconServicenow,
  mc as DtIconSettings,
  pc as DtIconShare,
  vc as DtIconShare2,
  uc as DtIconShareScreen,
  gc as DtIconSheet,
  dc as DtIconShield,
  fc as DtIconShieldAlert,
  bc as DtIconShieldCheck,
  Dc as DtIconShieldClose,
  Ic as DtIconShieldOff,
  hc as DtIconShortcuts,
  kc as DtIconShuffle,
  yc as DtIconSidebar,
  Cc as DtIconSidebarClose,
  wc as DtIconSidebarOpen,
  Sc as DtIconSignalBest,
  Mc as DtIconSignalHigh,
  Bc as DtIconSignalLow,
  Ac as DtIconSignalMedium,
  Fc as DtIconSignalZero,
  Lc as DtIconSimultaneousRing,
  Pc as DtIconSiren,
  Tc as DtIconSkip15Sec,
  Oc as DtIconSkipBack,
  Rc as DtIconSkipBackTen,
  zc as DtIconSkipForward,
  xc as DtIconSkipForwardTen,
  Uc as DtIconSlack,
  Hc as DtIconSlash,
  Vc as DtIconSliders,
  Gc as DtIconSlidersHorizontal,
  Wc as DtIconSmallSelfView,
  Nc as DtIconSmartphone,
  Ec as DtIconSmartphoneCharging,
  qc as DtIconSnapchat,
  Zc as DtIconSnooze,
  jc as DtIconSnowflake,
  Xc as DtIconSomewhatDissatisfied,
  Qc as DtIconSomewhatDissatisfiedFilled,
  Kc as DtIconSomewhatSatisfied,
  Jc as DtIconSomewhatSatisfiedFilled,
  Yc as DtIconSortAsc,
  $c as DtIconSortDesc,
  _n as DtIconSparkle,
  on as DtIconSparkleFilled,
  rn as DtIconSpeaker,
  sn as DtIconStar,
  tn as DtIconStarFilled,
  en as DtIconSticker,
  nn as DtIconStopCircle,
  cn as DtIconStopCircleFilled,
  ln as DtIconStopFilled,
  an as DtIconStrikethrough,
  un as DtIconSun,
  mn as DtIconSunDim,
  vn as DtIconSunMedium,
  pn as DtIconSunrise,
  gn as DtIconSunset,
  fn as DtIconSwitchToCellular,
  bn as DtIconSwitchToHd,
  Dn as DtIconTMobile,
  In as DtIconTable,
  dn as DtIconTag,
  hn as DtIconTags,
  kn as DtIconTakeover,
  Cn as DtIconTask,
  wn as DtIconTelegram,
  Sn as DtIconTextCursor,
  yn as DtIconTextCursorInput,
  An as DtIconThermometer,
  Mn as DtIconThermometerSnowflake,
  Bn as DtIconThermometerSun,
  Fn as DtIconThread,
  Ln as DtIconThreads,
  Tn as DtIconThumbsDown,
  Pn as DtIconThumbsDownFilled,
  On as DtIconThumbsUp,
  Rn as DtIconThumbsUpFilled,
  xn as DtIconTiktok,
  Hn as DtIconTimer,
  zn as DtIconTimerOff,
  Un as DtIconTimerReset,
  Gn as DtIconToggl,
  Vn as DtIconToken,
  Wn as DtIconTooManyQueries,
  En as DtIconTools,
  Nn as DtIconToyBrick,
  Zn as DtIconTransfer,
  qn as DtIconTransferWebchat,
  jn as DtIconTransportation,
  Qn as DtIconTrash,
  Xn as DtIconTrendingDown,
  Jn as DtIconTrendingUp,
  Kn as DtIconTriangle,
  Yn as DtIconTwitter,
  $n as DtIconType,
  ol as DtIconUmbrella,
  _l as DtIconUnderline,
  il as DtIconUndo2,
  rl as DtIconUnionPay,
  tl as DtIconUnlink2,
  el as DtIconUnlock,
  sl as DtIconUnlockFilled,
  cl as DtIconUnread,
  ll as DtIconUpload,
  nl as DtIconUploadCloud,
  al as DtIconUsb,
  bl as DtIconUser,
  ml as DtIconUserCheck,
  vl as DtIconUserMinus,
  ul as DtIconUserPlus,
  pl as DtIconUserRematch,
  gl as DtIconUserRemove,
  fl as DtIconUserSpeak,
  Dl as DtIconUsers,
  dl as DtIconVeryDissatisfied,
  Il as DtIconVeryDissatisfiedFilled,
  kl as DtIconVerySatisfied,
  hl as DtIconVerySatisfiedFilled,
  Cl as DtIconViber,
  Sl as DtIconVideo,
  wl as DtIconVideoOff,
  yl as DtIconVideoSettings,
  Ml as DtIconVisa,
  Al as DtIconVoicemail,
  Bl as DtIconVoicemailDrop,
  Tl as DtIconVolume,
  Fl as DtIconVolume1,
  Ll as DtIconVolume2,
  Pl as DtIconVolumeX,
  Rl as DtIconWaveform,
  Ol as DtIconWeChat,
  xl as DtIconWebcam,
  zl as DtIconWebchat,
  Ul as DtIconWebex,
  Gl as DtIconWhatsapp,
  Hl as DtIconWhatsappOutlined,
  Vl as DtIconWhisper,
  El as DtIconWifi,
  Wl as DtIconWifiOff,
  Nl as DtIconWind,
  ql as DtIconXBrand,
  Zl as DtIconXCircle,
  jl as DtIconZapOff,
  Ql as DtIconZendesk,
  Kl as DtIconZoho,
  Xl as DtIconZohoCrm,
  Jl as DtIconZohoDesk,
  _a as DtIconZoom,
  Yl as DtIconZoomIn,
  $l as DtIconZoomLogo,
  oa as DtIconZoomOut,
  ia as DtIllustrationAccessDenied,
  ra as DtIllustrationAtomicPathway,
  ta as DtIllustrationBlackHole,
  sa as DtIllustrationBlankSpace,
  ea as DtIllustrationBrowserTableGraph,
  aa as DtIllustrationDialpadLogo,
  ca as DtIllustrationDialpadLogoBlack,
  na as DtIllustrationDialpadLogoInverted,
  la as DtIllustrationDialpadLogoWhite,
  pa as DtIllustrationDialpadMono,
  ma as DtIllustrationDialpadMonoBlack,
  va as DtIllustrationDialpadMonoInverted,
  ua as DtIllustrationDialpadMonoWhite,
  ga as DtIllustrationFileUpload,
  fa as DtIllustrationLoginError,
  ba as DtIllustrationMagnifier,
  Da as DtIllustrationMicDetected,
  Ia as DtIllustrationMind,
  da as DtIllustrationMobileFullNotifications,
  ha as DtIllustrationNewMeeting,
  ka as DtIllustrationNewMessage,
  Ca as DtIllustrationNothingToSeeHere,
  wa as DtIllustrationOrbitalHarmony,
  ya as DtIllustrationPlaylist,
  Sa as DtIllustrationPublishGraphic,
  Ma as DtIllustrationSomethingWentWrong,
  Ba as DtIllustrationVectorVortex,
  Aa as DtIllustrationWirelessScreenshare,
  sh as icons,
  eh as illustrations
};
//# sourceMappingURL=dialtone-icons.js.map
